/*
 * @description： 通用滚动吸顶导航栏
 */
import classnames from 'classnames';
import React, { useCallback } from 'react';
import { StaticToast } from 'src/components/common';
import { uploadFile } from 'src/network/prescription';

export interface FileInputProps {
  className?: string;
  id?: string;
  name?: string;

  // 每张图上传成功后的回调
  onUploadSuccess: Function;

  // 上传前的验证
  onUploadBeforeValidate?: Function;

  // 最大上传张数
  maxAttachmentTotal?: number;

  // 已上传张图
  hasAttachmentTotal?: number;

  // 图片大小限制
  maxSize?: number;

  // 业务编号
  businessNo: string;

  // 业务类型
  attachmentType: string;
  // 业务场景
  platformCode?: 'ZA' | 'UMP';
  // 上传接口
  uploadAction?: (data) => Promise<any>;
}
const MAXSIZE = 30 * 1024 * 1024; // 图片最大 20M
const CompatibleFileInput = (props: FileInputProps) => {
  const { businessNo, attachmentType = '', className = '', name = 'file[]', id = 'upload_file', onUploadSuccess, maxAttachmentTotal = 9, hasAttachmentTotal = 0, maxSize = MAXSIZE, platformCode = '', onUploadBeforeValidate, uploadAction = uploadFile } = props;
  const recursionUploadImg = (files, usableTotal, index) => {
    if (index >= usableTotal) {
      return;
    }
    const itmeFile = files[index];
    if (!itmeFile) {
      return;
    }
    console.log('files', files);
    const maxTips = files.length ? `第${index}张` : '';
    if (itmeFile.size > maxSize) {
      StaticToast.warning(`${maxTips}图片超过大小限制`);
      recursionUploadImg(files, usableTotal, index + 1);
      return;
    }
    if (!/png|jpg|jpeg/.test(itmeFile.type)) {
      StaticToast.warning('只支持上传png，jpg和jpeg格式的图片');
      recursionUploadImg(files, usableTotal, index + 1);
      return;
    }
    const formData = new FormData();

    formData.append('files', itmeFile);
    // formData.append('businessNo', businessNo);
    // formData.append('attachmentType', attachmentType);
    // files.forEach(item => {
    //   formData.append('files', item);
    // })
    uploadAction(formData).then((res) => {
      if (res.success && res.result) {
        const uploadResult = Object.keys(res.result).map((key) => {
          onUploadSuccess({ localLink: window.URL.createObjectURL(itmeFile), id: key, url: res.result[key] });
        });
      }
      recursionUploadImg(files, usableTotal, index + 1);
    });
  };
  // 上传附件
  const uploadFileChange = useCallback(
    (e) => {
      console.log('e', e);
      const fileList = (e.target && e.target.files) || [];
      if (typeof onUploadBeforeValidate === 'function' && !onUploadBeforeValidate()) {
        return;
      }
      const recursionFileList: any = [];
      for (let i = 0; i < fileList.length; i++) {
        recursionFileList.push(fileList[i]);
      }
      const usableTotal = maxAttachmentTotal - hasAttachmentTotal;
      usableTotal > 0 && recursionUploadImg(recursionFileList.slice(0, usableTotal), usableTotal, 0);
      e.target.value = '';
    },
    [maxAttachmentTotal, hasAttachmentTotal, businessNo, attachmentType, onUploadSuccess, platformCode],
  );
  const isMultiple = true;
  return <input type="file" name={name} accept="image/*" multiple={isMultiple} id={id} className={classnames('upload-input', { [`${className}`]: !!className })} onChange={(e) => uploadFileChange(e)} />;
};

export default CompatibleFileInput;
